

const defaultMapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    zoomControl: false,
    fullscreenControl: false,
    styles: [
        {
            elementType: "labels",
            featureType: "poi.government",
            stylers: [{ visibility: "on" }],
        },
        {
            elementType: "labels",
            featureType: "poi.attraction",
            stylers: [{ visibility: "off" }],
        },
        {
            elementType: "labels",
            featureType: "poi.business",
            stylers: [{ visibility: "off" }],
        },
        {
            elementType: "labels",
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "off" }],
        }
    ]
}

export { defaultMapOptions }